import { Body3 } from '@/components/typography/body/bodies.component';
import { cn } from '@/lib/utils';
import { CircleAlert } from 'lucide-react';

type BannerProps = {
  text: React.ReactNode;
  className?: string;
};

export function Banner({ className, text }: BannerProps) {
  return (
    <div className={cn('gap-3 py-3 px-4 w-full items-center flex flex-row', className)}>
      <CircleAlert />
      <Body3>{text}</Body3>
    </div>
  );
}
